import { Typography } from "antd";

import { Column, Row } from "Components/shared/Flexbox";

import { BaseFlowNodeContainer } from "../Shared/BaseFlowNodeContainer/BaseFlowNodeContainer";
import { TopHandle } from "../Shared/FlowNodeHandles";
import { BottomHandle, LeftHandle } from "../Shared/FlowNodeHandles/MultiBottomHandle";

import styles from "../Shared/FlowNodes.module.scss";

type NodeProps = {
    id: string;
    isConnectable: boolean;
    selected: boolean;
    children: JSX.Element;
    connectingNodesFrom: string | null;
    removeNodeIcon: JSX.Element | null;
    isHorizontal?: boolean;
    className?: string;
};

export function BranchNode({
    id,
    isConnectable,
    isHorizontal,
    selected,
    children,
    connectingNodesFrom,
    removeNodeIcon,
    className,
}: NodeProps) {
    return (
        <BaseFlowNodeContainer selected={selected} connectingNodesFrom={!!connectingNodesFrom} className={className}>
            <>
                {isHorizontal ? (
                    <LeftHandle isConnectable={isConnectable} />
                ) : (
                    <TopHandle isConnectable={isConnectable} />
                )}
                {removeNodeIcon}
                {children}
                {isHorizontal ? null : (
                    <Row justifyContent="space-evenly" className={styles.branchNodeContent}>
                        <Column alignItems="center" className={styles.handleContentText}>
                            <Typography.Text>Yes</Typography.Text>
                            <BottomHandle id={`${id}-true`} isConnectable={isConnectable} />
                        </Column>

                        <Column alignItems="center" className={styles.handleContentText}>
                            <Typography.Text className={styles.optionText}>No</Typography.Text>
                            <BottomHandle id={`${id}-false`} isConnectable={isConnectable} />
                        </Column>
                    </Row>
                )}
            </>
        </BaseFlowNodeContainer>
    );
}
